import PropTypes from "prop-types"
import { RiSpam2Line } from "react-icons/ri"

import theme from "@/theme"

import { ErrorMessage } from "./styled"

/** This component renders an error text. */
export const ErrorText = ({ message }) => (
  <ErrorMessage>
    <RiSpam2Line size={theme.sizes.xtrasmall} />
    <span>{message}</span>
  </ErrorMessage>
)

ErrorText.propTypes = {
  /** The error message */
  message: PropTypes.string.isRequired,
}
